import { useMemo } from 'react';
import {
  useBackend,
  useBackendMutation,
  type WealthCreateConvertParams,
} from '@/backend';
import { useLazyValue } from '@/shared/react';

export const useConvertPreview = (
  payload: Partial<WealthCreateConvertParams>,
) =>
  useBackend(
    'wealth:get:convert/preview/',
    payload as WealthCreateConvertParams,
    {
      enabled:
        !!payload.from_coin &&
        !!payload.to_coin &&
        (!!payload.from_amount || !!payload.to_amount) &&
        (payload.from_amount ? +payload.from_amount !== 0 : true) &&
        (payload.to_amount ? +payload.to_amount !== 0 : true),
      swrOptions: {
        onError: () => {},
        dedupingInterval: 1000 * 10,
        refreshInterval: 1000 * 10,
      },
    },
  );

export const useConvert = () => useBackendMutation('wealth:post:convert/');

export const useConvertVerify = () =>
  useBackendMutation('wealth:post:convert/{slug}/verify/', {
    revalidate: ['wealth:*'],
  });

export const useCalculatePrice = (
  fromCoin: string,
  toCoin: string,
  price?: string,
  priceType?: 'from' | 'to',
) => {
  const dto = useMemo(
    () => ({
      from_coin: fromCoin,
      to_coin: toCoin,
      ...(priceType === 'to'
        ? {
            to_amount: price,
          }
        : {
            from_amount: price,
          }),
    }),
    [fromCoin, toCoin, price, priceType],
  );
  const lazyDto = useLazyValue(dto, 500);
  const convertPreview = useConvertPreview(lazyDto);

  return {
    ...convertPreview,
    isLoading: convertPreview.isLoading || dto !== lazyDto || !priceType,
  };
};
